const preMokelayDomain = 'https://pre-cn-x-gateway.cainiao.com';
const pageDataSource = 'pageDataSource';
const _dataSourceName = '_dataSourceName';
const onFieldValueChange = 'onFieldValueChange';
const AfterRequestSuccess = 'AfterRequestSuccess';
const columnSuffix = 'Column';
const dataOriginStatic = 'static';
const dataOriginRequest = 'request';
// 允许选择默认第一项的组件列表
const allowSelectFirstComponentList = ['Select'];
const formUrlencoded = 'application/x-www-form-urlencoded';
// 有循环渲染的组件
const recursionComponentList = ['CnFormArrayCard', 'CnArraySubAreaCard'];
// 高级配置关键词
const __advancedConfig__ = '__advancedConfig__';
// 源码相关
const __advancedCodeConfig__ = '__advancedCodeConfig__';
// 需要使用数据的动作编排类型
const needSaveDataFlowActionList = ['request', 'submit', 'jsbridge'];
// 缓存表单下拉框的ref
const formComponentRefStorage = {};

const __CnFormatPluginPrefix__ = 'CnFormatPlugin-';

/**
 * 移动端专用
 */
const allowQuickComponentList = [
  'CnSelect',
  'CnCascaderSelect',
  'CnAsyncSelect',
  'CnDepartmentSelect',
  'CnEmployeeSelect',
  'CnSelector',
  'CnCheckboxGroup',
  'CnRadioGroup',
  'CnDatePickerPro',
  'CnDateRangePickerPro',
];

export {
  preMokelayDomain,
  pageDataSource,
  _dataSourceName,
  onFieldValueChange,
  AfterRequestSuccess,
  columnSuffix,
  dataOriginStatic,
  dataOriginRequest,
  allowSelectFirstComponentList,
  formUrlencoded,
  recursionComponentList,
  __advancedConfig__,
  __advancedCodeConfig__,
  needSaveDataFlowActionList,
  formComponentRefStorage,
  allowQuickComponentList,
  __CnFormatPluginPrefix__,
};
